// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  figures: "SectionWages__figures",
  panelKey: "SectionWages__panelKey",
  panels: "SectionWages__panels",
  rowTitle: "SectionWages__rowTitle",
  section: "SectionWages__section",
};
